import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Paper, styled, Button, keyframes } from '@mui/material';
import { NavbarButton } from './NavbarButton';
import { WHITE, GREY1} from '../../constants/colors';

const slideInRight = keyframes`
  from {
    transform: translateX(10%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const DropdownContainer = styled(Paper)(() => ({
  position: 'absolute',
  top: 'calc(100% - 4px)',
  left: '-60px', 
  width: '240px',
  height: '172px',
  backgroundColor: WHITE,
  boxShadow: '0px 4px 4px 0px #00000040',
  borderRadius: '4px',
  padding: '6px 4px',

  zIndex: 1500,
  display: 'flex',
  flexDirection: 'column',
  gap: 0,
  animation: `${slideInRight} 300ms ease-out`,
}));

const DropdownItem = styled(Button)(() => ({
  width: '232px',
  height: '40px',
  padding: '0 16px',
  borderRadius: '4px',
  color: GREY1,


  fontFamily: '"Noto Sans TC", sans-serif',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '20px',
  textAlign: 'left',
  justifyContent: 'left',
  margin: '0 auto',

  '&:hover': {
    backgroundColor: 'transparent',
  },
  '&:active': {
    backgroundColor: 'transparent',
  },
}));

interface CompanyReferralDropdownProps {
  isLoggedIn?: boolean;
  isReferrer?: boolean;
}

export const CompanyReferralDropdown = ({ isLoggedIn, isReferrer }: CompanyReferralDropdownProps) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleMouseEnter = () => setOpen(true);
  const handleMouseLeave = () => setOpen(false);

  return (
    <Box
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      sx={{ 
        position: 'relative', 
        display: 'inline-block',
        paddingBottom: '8px',
        marginBottom: '-8px'
      }}
    >
      <NavbarButton
        disableRipple
      >
        公司內推
      </NavbarButton>

      {open && (
        <DropdownContainer elevation={0}>
          <DropdownItem onClick={() => navigate('/companies')} disableRipple>
            內推公司列表
          </DropdownItem>

          <DropdownItem onClick={() => navigate('/signup?type=referrer')} disableRipple>
            成為推薦人
          </DropdownItem>

          <DropdownItem onClick={() => navigate(isLoggedIn ? '/applications/sent' : '/signin')} disableRipple>
            別人推我
          </DropdownItem>

          <DropdownItem onClick={() => navigate(isLoggedIn ? '/applications' : '/signin')} disableRipple>
            我推別人
          </DropdownItem>
        </DropdownContainer>
      )}
    </Box>
  );
};

